export default __webpack_public_path__ + "static/media/pencil.47796810.png";